import React from 'react';
import { Deal } from '../../../deals/redux/types';

interface DealTagsProps {
    dealsData: Deal;
    limit: number | undefined;
}

const DealTags: React.FC<DealTagsProps> = ({ dealsData, limit = undefined }) => {
    const combineTags = [
        dealsData.status,
        ...(dealsData?.dealTags?.headlinerTags?.map((ht: any) => ht.name) || []),
        ...(dealsData?.dealTags?.tags?.map((t: any) => t.name) || []),
    ];
    return (
        <div className={`md:w-5/6 w-full flex flex-wrap items-center  ${limit ? 'pr-4 py-4' : ''}`}>
            {combineTags.splice(0, limit || combineTags.length).map((t, index) => (
                <div
                    className="bg-[#142C53] mr-1 leading-[0] p-[14px] px-[8px] text-xs text-white mb-1 font-[WorkSans-Semibold] font-semibold"
                    key={index}
                >
                    {t}
                </div>
            ))}
        </div>
    );
};

export default DealTags;
